"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/**
* StaticItem Molecule

* @author s.palacios
* @describe
  Renders a link component or a Typeography text element with proper translation, used for static items not drive by Contentful
  items are predefined in type ItemsAvailable, and gets localization from the Applications Context which is assume
  to be present. This component will be utilized by Header, Footer to render links and static text.
  @dependency
  Application Context
  Link Component
  Typography Component

*/


var react_1 = __importDefault(require("react"));

var frontend_navigation_1 = require("@ryerson/frontend.navigation");

var frontend_typography_1 = require("@ryerson/frontend.typography");

var styled_1 = __importDefault(require("@emotion/styled"));

var react_2 = require("@emotion/react");

var frontend_application_1 = require("@ryerson/frontend.application");

var frontend_common_1 = require("@ryerson/frontend.common");

var ClickableLink = styled_1.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tdisplay: block;\n\twidth: auto;\n\theight: auto;\n\tcursor: pointer;\n"])));

var StaticItem = function StaticItem(_ref) {
  var itemName = _ref.itemName,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "sm" : _ref$size,
      weight = _ref.weight,
      color = _ref.color,
      type = _ref.type,
      _ref$returnType = _ref.returnType,
      returnType = _ref$returnType === void 0 ? "link" : _ref$returnType,
      breakPoint = _ref.breakPoint;

  var _ref2 = (0, frontend_application_1.useApplication)(),
      _ref2$localization = _ref2.localization,
      language = _ref2$localization.language,
      country = _ref2$localization.country;

  var getRedirectURL = function getRedirectURL(url) {
    if (url.charAt(0) === "/" && url.charAt(1) === "/") {
      return url;
    }

    var redirectURL = url;

    if (typeof window !== "undefined") {
      redirectURL = window.location.origin + url;
    }

    return redirectURL;
  };

  var content = [{
    name: "signUp",
    url: "/register",
    display: frontend_common_1.withTranslation["signUp"][language],
    active: true
  }, {
    name: "allLocations",
    url: "/locations/".concat(frontend_application_1.CountryUrl[country]),
    display: frontend_common_1.withTranslation["allLocations"][language],
    active: true
  }, {
    name: "allRightsReserved",
    url: "/all-rights-reserved",
    display: frontend_common_1.withTranslation["allRightsReserved"][language],
    active: true
  }, {
    name: "followUs",
    url: "follow-us",
    display: frontend_common_1.withTranslation["followUs"][language],
    active: true
  }, {
    name: "usStatePrivacyDisclosure",
    url: "/us-state-privacy-disclosure",
    display: frontend_common_1.withTranslation["usStatePrivacyDisclosure"][language],
    active: true
  }, {
    name: "californiaTransparencySupplyChainAct",
    url: "/california-transparency-supply-chain-act",
    display: frontend_common_1.withTranslation["californiaTransparencySupplyChainAct"][language],
    active: true
  }, {
    name: "securityStatement",
    url: "/security-statement",
    display: frontend_common_1.withTranslation["securityStatement"][language],
    active: true
  }, {
    name: "termsAndConditions",
    url: "/terms-and-conditions",
    display: frontend_common_1.withTranslation["termsAndConditions"][language],
    active: true
  }, {
    name: "privacyPolicy",
    url: "/privacy-policy",
    display: frontend_common_1.withTranslation["privacyPolicy"][language],
    active: true
  }, {
    name: "liveChat",
    display: frontend_common_1.withTranslation["liveChat"][language],
    active: true
  }, {
    name: "locations",
    url: "/locations",
    display: frontend_common_1.withTranslation["locations"][language],
    active: true
  }, {
    name: "getStocklist",
    url: "/stock-list",
    display: frontend_common_1.withTranslation["getStocklist"][language],
    active: true
  }, {
    name: "contactUs",
    url: "/contact-us",
    display: frontend_common_1.withTranslation["contactUs"][language],
    active: true
  }, {
    name: "transparencyInCoverage",
    url: "//www.bcbsil.com/asomrf?EIN=361717960",
    display: frontend_common_1.withTranslation["transparencyInCoverage"][language],
    active: true
  }];
  var linkItem = content.filter(function (linkDataItem) {
    return linkDataItem.name === itemName;
  })[0]; // The header and footer has to treat all links as external since we don't know which links
  // will be reference a different application.

  return (0, jsx_runtime_1.jsx)(react_1.default.Fragment, {
    children: linkItem.name === "liveChat" ? (0, jsx_runtime_1.jsx)(ClickableLink, {
      onClick: function onClick() {
        if (window && window.LiveChatWidget) window.LiveChatWidget.call("maximize");
      },
      "data-testid": "".concat(linkItem.name, "-link-click"),
      children: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
        size: size,
        type: type,
        breakPoint: breakPoint,
        weight: weight,
        color: color,
        children: linkItem.display
      })
    }) : returnType === "link" || returnType === "external-link" ? linkItem.url ? (0, jsx_runtime_1.jsx)(frontend_navigation_1.Link, {
      disabled: !linkItem.active,
      size: size,
      breakPoint: breakPoint,
      css: (0, react_2.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t", "\n\t\t\t\t\t\t"])), breakPoint && "\n                                white-space:pre-wrap;\n                                @media only screen and (max-width: ".concat(breakPoint, "px) { \n                                    white-space:normal; \n                                }\n                            }")),
      type: type,
      to: getRedirectURL(linkItem.url),
      color: color,
      gatsby: false,
      dataTestId: "".concat(returnType, "-click"),
      children: linkItem.display
    }) : (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
      size: size,
      type: type,
      breakPoint: breakPoint,
      weight: weight,
      color: color,
      children: linkItem.display
    }) : (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
      breakPoint: breakPoint,
      size: size,
      weight: weight,
      color: color,
      children: linkItem.display
    })
  });
};

exports.default = StaticItem;